<template>
  <a-modal
    :open="open"
    title="内测合作协议签署"
    :closable="false"
    :mask="{ closable: false }"
    :keyboard="false"
    :footer="null"
    :width="600"
  >
    <div class="agreement-content">
      <h3>“{{ agreementProductLabel }}”产品内测合作协议</h3>
      <div class="agreement-text">
        <p>欢迎参与 “{{ agreementProductLabel }}” 产品内测。在使用本产品前，请您仔细阅读以下条款：</p>
        <p>1. 本产品目前处于内测阶段，功能可能随时调整。</p>
        <p>2. 您在使用过程中产生的数据将仅用于产品优化。</p>
        <p>3. 请勿向第三方泄露本产品的任何内部信息。</p>
        <p>4. 平台保留随时终止内测服务的权利。</p>
        <p>（更多详细条款请咨询客服或查看完整版协议文档）</p>
      </div>
      
      <div class="agreement-actions">
        <a-checkbox v-model:checked="agreed">
          我已阅读并同意《“{{ agreementProductLabel }}”产品内测合作协议》
        </a-checkbox>
        
        <div class="btn-group">
          <a-button 
            type="primary" 
            :disabled="!agreed" 
            :loading="loading"
            @click="handleSign"
            block
          >
            签署并提交
          </a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { message } from 'antdv-next';
import { useAuthStore } from '@/stores/auth';
import { isFTDMode, isUGJMode } from '@utils/productMode';

defineProps<{
  open: boolean;
}>();

const emit = defineEmits<{
  (e: 'success'): void;
}>();

const authStore = useAuthStore();
const agreed = ref(false);
const loading = ref(false);

/**
 * 根据打包模式切换协议文案，避免 FTD 用户看到“包面试”心智。
 */
const agreementProductLabel = computed(() => {
  if (isFTDMode) return '邀约简历'
  if (isUGJMode) return '包面试'
  return '平台产品'
})

import userService from '@/services/UserService';

const handleSign = async () => {
  if (!agreed.value) return;
  
  loading.value = true;
  try {
    const user = authStore.user;
    if (user) {
      // 调用签署协议接口
      const res = await userService.signAgreement();
      if (res.success) {
        // 刷新本地 store 状态
        await authStore.fetchUser();
        
        message.success('协议签署成功');
        emit('success');
      } else {
        throw new Error(res.error?.message || '签署失败');
      }
    }
  } catch (error) {
    const err = error as { message?: string }
    message.error(err.message || '签署失败，请重试');
    console.error(err);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped lang="scss">
.agreement-content {
  padding: 10px;
  
  h3 {
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
  }
  
  .agreement-text {
    height: 300px;
    overflow-y: auto;
    background: #f5f5f5;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    line-height: 1.6;
    border: 1px solid #e8e8e8;
    
    p {
      margin-bottom: 10px;
    }
  }
  
  .agreement-actions {
    display: flex;
    flex-direction: column;
    gap: 15px;
    
    .btn-group {
      margin-top: 10px;
    }
  }
}
</style>
